<template>
  <FormulateForm v-model="form" :errors="formErrors" :schema="schema" @submit="submitForm" />
</template>
<script>
export default {
  props: {
    address: {
      type: String,
      required: true,
    },
    reasons: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: {
        reason: null,
      },
      formErrors: null,
    };
  },
  computed: {
    addressField() {
      return {
        name: 'address',
        type: 'text',
        readonly: true,
        value: this.address,
      };
    },
    reasonField() {
      return {
        name: 'reason',
        type: 'radio',
        class: 'formulate-input--small',
        options: this.reasons,
        validation: 'required',
        validationMessages: {
          required: 'El campo es obligatorio.',
        },
      };
    },
    backButton() {
      return {
        component: 'a',
        class: 'btn btn-ghost btn-lg',
        children: 'Volver',
        '@click': this.back,
      };
    },
    submitButton() {
      return {
        type: 'submit',
        name: 'submit',
        label: 'Obtener valoración',
      };
    },
    buttons() {
      return {
        component: 'div',
        class: 'btn-container',
        children: [this.backButton, this.submitButton],
      };
    },
    schema() {
      return [this.addressField, this.reasonField, this.buttons];
    },
  },
  methods: {
    submitForm() {
      this.$emit('submit', this.form);
    },
    back() {
      this.$emit('prevStep');
    },
  },
};
</script>
